import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, ClockIcon, MapPinIcon } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="bg-brand-black py-24 px-6" data-id="element-33">
      <div className="max-w-7xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center flex flex-col items-center" data-id="element-35">
          <div className="flex items-center gap-4 mb-4" data-id="element-36">
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-37" />
            <span className="font-condensed uppercase text-brand-green tracking-widest font-semibold" data-id="element-38">
              Contact Us
            </span>
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-39" />
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl text-white" data-id="element-40">
            GET IN <span className="text-brand-green" data-id="element-41">TOUCH</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-42">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-2 flex flex-col gap-8" data-id="element-43">
            <p className="font-barlow text-brand-gray text-lg leading-relaxed" data-id="element-44">
              Ready to reclaim your home from pests? Reach out today for a free
              inspection and custom treatment plan.
            </p>

            <div className="flex flex-col gap-6" data-id="element-45">
              <div className="flex items-start gap-4" data-id="element-46">
                <div className="w-12 h-12 bg-brand-green/10 border border-brand-green/30 flex items-center justify-center flex-shrink-0" data-id="element-47">
                  <PhoneIcon className="w-5 h-5 text-brand-green" data-id="element-48" />
                </div>
                <div data-id="element-49">
                  <h4 className="font-condensed uppercase text-white font-semibold tracking-wider text-lg" data-id="element-50">
                    Phone
                  </h4>
                  <a href="tel:5551234567" className="font-barlow text-brand-gray hover:text-brand-green transition-colors text-lg" data-id="element-51">
                    (555) 123-4567
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-52">
                <div className="w-12 h-12 bg-brand-green/10 border border-brand-green/30 flex items-center justify-center flex-shrink-0" data-id="element-53">
                  <MailIcon className="w-5 h-5 text-brand-green" data-id="element-54" />
                </div>
                <div data-id="element-55">
                  <h4 className="font-condensed uppercase text-white font-semibold tracking-wider text-lg" data-id="element-56">
                    Email
                  </h4>
                  <a href="mailto:info@ultimatepest.co" className="font-barlow text-brand-gray hover:text-brand-green transition-colors" data-id="element-57">
                    info@ultimatepest.co
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-58">
                <div className="w-12 h-12 bg-brand-green/10 border border-brand-green/30 flex items-center justify-center flex-shrink-0" data-id="element-59">
                  <ClockIcon className="w-5 h-5 text-brand-green" data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <h4 className="font-condensed uppercase text-white font-semibold tracking-wider text-lg" data-id="element-62">
                    Hours
                  </h4>
                  <p className="font-barlow text-brand-gray" data-id="element-63">
                    Mon–Fri: 8am – 6pm
                  </p>
                  <p className="font-barlow text-brand-gray" data-id="element-64">Sat: 9am – 2pm</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-65">
                <div className="w-12 h-12 bg-brand-green/10 border border-brand-green/30 flex items-center justify-center flex-shrink-0" data-id="element-66">
                  <MapPinIcon className="w-5 h-5 text-brand-green" data-id="element-67" />
                </div>
                <div data-id="element-68">
                  <h4 className="font-condensed uppercase text-white font-semibold tracking-wider text-lg" data-id="element-69">
                    Location
                  </h4>
                  <p className="font-barlow text-brand-gray" data-id="element-70">Queen Creek, AZ</p>
                  <p className="font-barlow text-brand-gray text-sm" data-id="element-71">
                    Serving the entire East Valley
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-3" data-id="element-72">
            {submitted ? <div className="bg-brand-card border border-brand-green/30 p-12 flex flex-col items-center justify-center text-center min-h-[400px]" data-id="element-73">
                <div className="w-16 h-16 bg-brand-green rounded-full flex items-center justify-center mb-6" data-id="element-74">
                  <span className="text-black text-3xl font-bold" data-id="element-75">✓</span>
                </div>
                <h3 className="font-bebas text-4xl text-white mb-3" data-id="element-76">
                  MESSAGE SENT!
                </h3>
                <p className="font-barlow text-brand-gray text-lg max-w-md" data-id="element-77">
                  Thanks for reaching out. We'll get back to you within 24 hours
                  to schedule your free inspection.
                </p>
                <button onClick={() => {
              setSubmitted(false);
              setFormData({
                name: '',
                email: '',
                phone: '',
                service: '',
                message: ''
              });
            }} className="mt-8 font-condensed uppercase tracking-wider text-brand-green hover:text-white transition-colors" data-id="element-78">
                  Send Another Message
                </button>
              </div> : <form onSubmit={handleSubmit} className="bg-brand-card border border-white/5 p-5 sm:p-8 md:p-10 space-y-5 md:space-y-6" data-id="element-79">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-80">
                  <div className="flex flex-col gap-2" data-id="element-81">
                    <label className="font-condensed uppercase text-white tracking-wider text-sm font-semibold" data-id="element-82">
                      Full Name *
                    </label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="John Smith" className="bg-brand-dark border border-white/10 text-white font-barlow px-4 py-3 focus:border-brand-green focus:outline-none transition-colors placeholder:text-white/20" data-id="element-83" />
                  </div>
                  <div className="flex flex-col gap-2" data-id="element-84">
                    <label className="font-condensed uppercase text-white tracking-wider text-sm font-semibold" data-id="element-85">
                      Email *
                    </label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="john@example.com" className="bg-brand-dark border border-white/10 text-white font-barlow px-4 py-3 focus:border-brand-green focus:outline-none transition-colors placeholder:text-white/20" data-id="element-86" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-87">
                  <div className="flex flex-col gap-2" data-id="element-88">
                    <label className="font-condensed uppercase text-white tracking-wider text-sm font-semibold" data-id="element-89">
                      Phone
                    </label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="(555) 123-4567" className="bg-brand-dark border border-white/10 text-white font-barlow px-4 py-3 focus:border-brand-green focus:outline-none transition-colors placeholder:text-white/20" data-id="element-90" />
                  </div>
                  <div className="flex flex-col gap-2" data-id="element-91">
                    <label className="font-condensed uppercase text-white tracking-wider text-sm font-semibold" data-id="element-92">
                      Service Needed
                    </label>
                    <select name="service" value={formData.service} onChange={handleChange} className="bg-brand-dark border border-white/10 text-white font-barlow px-4 py-3 focus:border-brand-green focus:outline-none transition-colors appearance-none" data-id="element-93">
                      <option value="" className="bg-brand-dark" data-id="element-94">
                        Select a service...
                      </option>
                      <option value="ant" className="bg-brand-dark" data-id="element-95">
                        Ant Control
                      </option>
                      <option value="spider" className="bg-brand-dark" data-id="element-96">
                        Spider Treatment
                      </option>
                      <option value="rodent" className="bg-brand-dark" data-id="element-97">
                        Rodent Exclusion
                      </option>
                      <option value="mosquito" className="bg-brand-dark" data-id="element-98">
                        Mosquito Defense
                      </option>
                      <option value="roach" className="bg-brand-dark" data-id="element-99">
                        Roach Elimination
                      </option>
                      <option value="wasp" className="bg-brand-dark" data-id="element-100">
                        Wasp & Bee Removal
                      </option>
                      <option value="scorpion" className="bg-brand-dark" data-id="element-101">
                        Scorpion Control
                      </option>
                      <option value="general" className="bg-brand-dark" data-id="element-102">
                        General Pest Control
                      </option>
                      <option value="other" className="bg-brand-dark" data-id="element-103">
                        Other
                      </option>
                    </select>
                  </div>
                </div>

                <div className="flex flex-col gap-2" data-id="element-104">
                  <label className="font-condensed uppercase text-white tracking-wider text-sm font-semibold" data-id="element-105">
                    Message
                  </label>
                  <textarea name="message" value={formData.message} onChange={handleChange} rows={5} placeholder="Tell us about your pest problem..." className="bg-brand-dark border border-white/10 text-white font-barlow px-4 py-3 focus:border-brand-green focus:outline-none transition-colors resize-none placeholder:text-white/20" data-id="element-106" />
                </div>

                <button type="submit" className="bg-brand-green text-black font-bold px-10 py-4 clip-parallelogram hover:bg-white transition-colors font-condensed uppercase tracking-widest text-xl w-full sm:w-auto" data-id="element-107">
                  Send Message
                </button>
              </form>}
          </motion.div>
        </div>
      </div>
    </section>;
}